import React from 'react';
import PropTypes from 'prop-types';

import { SvgIcon } from '../../../../../../../../../common/react/components/SvgIcon';
import { StatsTableHead } from '../../../../../../../statspro/js/components/common/stats-table/StatsTableHead';

export const TableHead = ({
    headerGroup,
    sortByFavourites,
    setSortByFavourites
}) => {
    return (
        <StatsTableHead
            headerGroup={headerGroup}
            customCells={{
                player: (column) => (
                    <th
                        className="stats-table__header-cell"
                        scope="col"
                        key={column.id}
                    >
                        <button
                            className="stats-table__header-cell-button"
                            disabled={true}
                        >
                            <div
                                onClick={() =>
                                    setSortByFavourites(!sortByFavourites)
                                }
                                className="stats-table__header-cell-favourite-button"
                            >
                                {sortByFavourites ? (
                                    <SvgIcon
                                        icon="star-filled"
                                        className="icon"
                                    />
                                ) : (
                                    <SvgIcon
                                        icon="star-empty"
                                        className="icon"
                                    />
                                )}
                            </div>
                            {column.render('Header')}
                        </button>
                    </th>
                ),
                bettingOdds: (column) => (
                    <th
                        className="stats-table__header-cell"
                        scope="col"
                        colSpan="1"
                        role="columnheader"
                        key={column.id}
                    >
                        <button
                            className="stats-table__header-cell-button"
                            disabled={true}
                        >
                            <img
                                className="stats-table__sportsbet-callout"
                                src={`/resources/${window.RESOURCES_VERSION}/i/elements/sportsbet-callout.svg`}
                            />
                        </button>
                    </th>
                )
            }}
        />
    );
};

TableHead.propTypes = {
    headerGroup: PropTypes.object.isRequired,
    sortByFavourites: PropTypes.bool,
    setSortByFavourites: PropTypes.func
};
